import React from 'react';
import MainTable from './components/MainTables';

const Po = () => {
  return <MainTable />;
};

export default Po;
